import { StorageService } from '@empathy/storage-service';
import { inject, injectable, named } from 'inversify';
import { Store } from 'vuex';
import { DEPENDENCIES, STORAGE } from '../container/dependencies.const';
import { GETTERS_KEYS, RootStoreState } from '../store';

const STATE_CACHE_KEY = 'state-cache';

@injectable()
export class StateCacheService {

  constructor(
    @inject(DEPENDENCIES.StorageService) @named(STORAGE.Local) private readonly localStorage: StorageService) {}

  saveStateToCache(store: Store<RootStoreState>): void {
    if (store.getters[GETTERS_KEYS.config.config].core.enableCache) {
      const serializedState = JSON.stringify(store.state, this.avoidCyclesReplacer);
      this.localStorage.setItem(STATE_CACHE_KEY, serializedState);
    }
  }

  getStateFromCache(): RootStoreState {
    const parsedState: RootStoreState = JSON.parse(this.localStorage.getItem(STATE_CACHE_KEY));
    return parsedState ? this.reconstructCycles(parsedState) : null;
  }

  deleteStateFromCache(): void {
    this.localStorage.removeItem(STATE_CACHE_KEY);
  }

  // This method is added because we need to remove the loop that exists in the facets where each facet point to it self and enter in a
  // loop. This problem cause that you cannot stringify it. Also, we remove the config to reduce the state size in the localstore.
  avoidCyclesReplacer(key: string, value: any): string {
    if (key === 'facet'
      || (key === 'parent' && value !== null)
      || (key === 'config' && value['baseDevice'])
    ) {
      return undefined;
    }
    return value;
  }

  protected reconstructCycles(parsedState: RootStoreState): RootStoreState {
    const facets = parsedState.search.facets;
    Object.keys(facets).forEach(facet => {
      facets[facet].filters.forEach(filter => {
        filter.facet = facets[facet];
        filter.children.forEach(childrenFilter => {
          childrenFilter.parent = filter;
        });
        return filter;
      });
    });
    return parsedState;
  }
}
